// src/store.js (or src/redux/store.js)
import { configureStore } from "@reduxjs/toolkit";
import integrationReducer from "./slices/integrationSlice";
import authReducer from "./slices/authSlice"; // Adjust the path as needed

export const store = configureStore({
  reducer: {
    auth: authReducer,
    integration: integrationReducer, // Add the integration reducer
  },
});

// // Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch;
